var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconFolder = function SvgIconFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 0.666748H3.66634C1.83301 0.666748 0.349674 2.16675 0.349674 4.00008L0.333008 24.0001C0.333008 25.8334 1.83301 27.3334 3.66634 27.3334H30.333C32.1663 27.3334 33.6663 25.8334 33.6663 24.0001V4.00008C33.6663 2.16675 32.1663 0.666748 30.333 0.666748ZM28.6663 24.0001H5.33301C4.41634 24.0001 3.66634 23.2501 3.66634 22.3334V7.33341L15.233 14.5667C16.3163 15.2501 17.683 15.2501 18.7663 14.5667L30.333 7.33341V22.3334C30.333 23.2501 29.583 24.0001 28.6663 24.0001ZM16.9997 12.3334L3.66634 4.00008H30.333L16.9997 12.3334Z",
    fill: "#FF4713"
  })));
};

export default __webpack_public_path__ + "static/media/IconFolder.4df1ee7f.svg";
export { SvgIconFolder as ReactComponent };